const isPagarmeTestPublicKey = (publicKey) => {
	if (!publicKey) return false;

	const key = publicKey.trim().toLowerCase();
	return key.startsWith('pk_test_') || key.includes('_test_');
};

const getPagarmePublicKey = () => {
	const publicKey = process.env.REACT_APP_PAGARME_PUBLIC_KEY || '';

	if (process.env.NODE_ENV !== 'production' && !isPagarmeTestPublicKey(publicKey)) {
		throw new Error(
			'REACT_APP_PAGARME_PUBLIC_KEY must be a Pagar.me test public key (pk_test_…) in development.'
		);
	}

	if (!publicKey) {
		throw new Error('Pagar.me public key not configured');
	}

	return publicKey;
};

export default {
	isPagarmeTestPublicKey,
	getPagarmePublicKey,
};
